export const UPDATE_SUBSCRIPTION_PRODUCTS = 'UPDATE_SUBSCRIPTION_PRODUCTS';
export const SET_HAS_CLICKED_SUBSCRIBE = 'SET_HAS_CLICKED_SUBSCRIBE';
